import { Navigate, useLocation, Link as RouterLink } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
import { PageLoader } from '@components/shared/PageLoader';
import { Box, Typography, Button } from '@mui/material';
import { Person } from '@mui/icons-material';

interface RequireMasterAdminProps {
  children: React.ReactNode;
}

export default function RequireMasterAdmin({ children }: RequireMasterAdminProps) {
  const { user, authReady } = useAuth();
  const location = useLocation();

  if (!authReady) {
    return <PageLoader />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Permite accesul tuturor utilizatorilor, dar afiseaza un mesaj pentru non-master-admin
  if (user.role !== 'master_admin') {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h4" color="warning.main" gutterBottom>
          Acces Restrictionat
        </Typography>
        <Typography variant="body1" paragraph>
          Aceasta sectiune este destinata doar administratorilor master.
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Rolul tau curent: <strong>{user.role}</strong>
        </Typography>
        <Button 
          variant="contained" 
          component={RouterLink} 
          to="/dashboard"
          startIcon={<Person />}
        >
          Mergi la Dashboard-ul tau
        </Button>
      </Box>
    );
  }

  return <>{children}</>;
}
